import React from 'react';
import { Gateway } from 'react-gateway';
import BackButton from '../containers/BackButton';
import { BACK_BUTTON_GATEWAY } from '../constants';

const WithBackButton = Component => props => (
  <div>
    <Gateway into={BACK_BUTTON_GATEWAY}>
      <BackButton />
    </Gateway>
    <Component {...props} />
  </div>
);

export default WithBackButton;



// WEBPACK FOOTER //
// ./src/app/kiosk/hoc/WithBackButton.jsx